class ClubDetailsOverlay extends HTMLElement {
  constructor() {
    super();
    this.closeOverlayHandler = this.close.bind(this);
    this.closeButtonHandler = this.close.bind(this);
    this.addClubToCartHandler = this.addClubToCart.bind(this);
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    // Set up overlay click to close the component
    this.overlay = this.querySelector('.panel-overlay');
    this.overlay?.addEventListener('click', this.closeOverlayHandler);

    // Set up close button
    this.closeButton = this.querySelector('.drawer_close');
    this.closeButton?.addEventListener('click', this.closeButtonHandler);

    //.add_club_to_cart
    this.addClubToCartBtn = this.querySelector('.add_club_to_cart');
    this.addClubToCartBtn?.addEventListener('click', this.addClubToCartHandler);
  }

  removeEventListeners() {
    this.overlay?.removeEventListener('click', this.closeOverlayHandler);
    this.closeButton?.removeEventListener('click', this.closeButtonHandler);
    this.addClubToCartBtn?.removeEventListener('click', this.addClubToCartHandler);
  }

  addClubToCart() {
    // Add club to cart logic here
    this.close();
    window.__abc.addClubMembershipToCart();
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    this.classList.add('active');

    // Trap focus inside the component using the global trapFocus function
    const containerToTrapFocusOn = this.querySelector('.drawer__inner');
    const focusElement = containerToTrapFocusOn || this.querySelector('.drawer_close');
    if (typeof trapFocus === 'function' && containerToTrapFocusOn) {
      trapFocus(containerToTrapFocusOn, focusElement);
    }

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');

    // Remove focus trap
    if (typeof removeTrapFocus === 'function' && this.activeElement) {
      removeTrapFocus(this.activeElement);
    }

    document.body.classList.remove('overflow-hidden');

    if (this.activeElement) {
      this.activeElement.focus();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('club-details-overlay', ClubDetailsOverlay);

/*
document.addEventListener('DOMContentLoaded', () => {
  const clubLinks = document.querySelectorAll('a[href="#add_club_membership_overlay"]');
  console.log({ clubLinks });
  clubLinks.forEach((clubLink) => {
    clubLink.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent the default hash navigation
      //console.log('clicked')
      const overlay = document.querySelector('club-details-overlay');
      //console.log(overlay)
      if (overlay) {
        overlay.open(clubLink);
      }
    });
  });
});
*/
function markClubOverlayTriggers() {
  document
    .querySelectorAll('a[href="#add_club_membership_overlay"], .add_club_membership_overlay')
    .forEach((link) => {
      if (!link.hasAttribute('aria-haspopup')) link.setAttribute('aria-haspopup', 'dialog');
    });
}

markClubOverlayTriggers();

// Cart drawer content (which includes a club-membership upsell trigger) re-renders
// via innerHTML replacement on every cart update, so watch for new matches.
new MutationObserver(markClubOverlayTriggers).observe(document.body, {
  childList: true,
  subtree: true,
});

document.body.addEventListener('click', (event) => {
  const links = document.querySelectorAll(
    'a[href="#add_club_membership_overlay"], .add_club_membership_overlay'
  );
  links.forEach((link) => {
    if (link.contains(event.target)) {
      event.preventDefault();
      const overlay = document.querySelector('club-details-overlay');
      overlay?.open(link);
    }
  });
  /*
  const link = event.target.closest('a[href="#add_club_membership_overlay"], a.add_club_membership_overlay');
  if (!link) return;

  event.preventDefault();
  const overlay = document.querySelector('club-details-overlay');
  overlay?.open(link);
  */
});
